<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" ref="input" :tabindex="tabindex" :disabled="isDisalbed ? true : null"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import FactorBunchList from '~/views/sale/factors/factor-bunch.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			tabindex: {},
			data: { type: Array },
			disabled: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				localIsDisabled: false,
				settings: {
					type: null,
					defaultFactorBunchId: null,
					ignoreDefaultFactorBunch: false,
					dropdownOptions: {
						rowIdentifier: 'id',
						selectorWidth: '250px',
						searchable: true,
						required: true,
						placeholder: this.$t('search-it'),
						display: (item) =>
							`${item.name} [${item.lastSerialNumber} - ${item.firstSerialNumber}]`,
						searchableFields: ['name', 'FirstSerialNumber', 'LastSerialNumber'],
						buttons: [{
							title: this.$t('list'),
							shortcut: $sc.find('enter'),
							isPrimary: true,
							element: () => this.$refs.input.$el,
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showFactorBunchList()
							}
						}]
					}
				},
				localValue: null,
				appStateValue: null,
			}
		},
		computed: {
			...mapGetters({
				all: 'factorBunches/all',
				getByType: 'factorBunches/getByType',
				getActiveState: 'appStates/getActiveByKey',
			}),
			isDisalbed() {
				return this.disabled || this.localIsDisabled
			},
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				var data

				if (this.data && this.data.length)
					data = this.data
				else if (this.settings.type)
					data = this.getByType(this.settings.type)
				else data = this.all

				if (data.length === 1 && !this.modelValue) {
					this.dropdownValue = data[0]
					this.localIsDisabled = true
				}
				else if (this.settings.type && this.appStateValue && data.find(x => x.id === this.appStateValue.id)) {
					this.setFactorBunchFromAppState(data)
				}
				else if (this.settings.defaultFactorBunchId) {
					this.filterByDefaultFactorBunchId(data)
				}
				return data.filter(x => x.isActive)
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					if (val && oldVal && val.id === oldVal.id)
						return
					if (this.dropdownValue?.id === val?.id)
						return
					this.dropdownValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
					if (this.settings.defaultFactorBunchId)
						this.filterByDefaultFactorBunchId()
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			this.refreshFactorBunches()

			if (!this.settings.defaultFactorBunchId)
				this.getSaleSettings()

			this.appStateValue = this.getActiveState(`FactorBunch_${this.settings.type}`)?.value
		},
		methods: {
			...mapActions({
				refreshFactorBunches: 'factorBunches/refresh',
				modifyStates: 'appStates/modify',
				syncStates: 'appStates/sync',
			}),
			setFactorBunchFromAppState(data = this.dropdownData) {
				let found = data.find(x => x.id === this.appStateValue.id)
				if (found && !this.modelValue) {
					this.dropdownValue = found
				}
			},
			filterByDefaultFactorBunchId(data = this.dropdownData) {
				let found = data.find(x => x.id === this.settings.defaultFactorBunchId)
				if (found && !this.modelValue) {
					this.dropdownValue = found
					// this.localIsDisabled = true
				}
			},
			getSaleSettings() {

				var url = Endpoints.getUrl('sale.settings.get')
				var wait = this.$wait(this.$refs.input.$el, { size: 'small' })

				post(url, null, null, { preventConcurrent: false })
					.then((result) => {
						if (!this.settings.ignoreDefaultFactorBunch)
							this.settings.defaultFactorBunchId = result.data.factorSettings.defaultFactorBunchId
						if (wait)
							wait.end()
					})
					.catch((error) => {
						if (wait)
							wait.end()
						this.defer(() => this.$refs.input.$el.focus(), 7)
					})
			},
			showFactorBunchList() {
				this.showModal({
					component: FactorBunchList,
					options: { selectable: true, factorType: this.settings.type },
				})
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
